import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';


import Iconset from '../icons';

class ArtworkSubmit extends React.Component{

	constructor(props){
		super(props);

		this.state = {
			value : ''
		}
	}

	

	render(){
		return (<div className="absolute artwork-submit-holder">
				<button className="artwork-submit-menu-close" onClick={this.props.closeSubmit}><Iconset.close /></button>	
				<div className="artwork-submit">
					<p>Submit your artwork and get the chance to win it as a printed and signed poster!</p>
					<form className="artwork-submit-form">
						<p>Enter your e-mail and be part of the raffle.</p>
						<div className={"artwork-input artwork-input-email-invalid-"+ this.props.wrongEmail}>
							<input onInput={(event)=>this.props.getEmail(event)} type="text" value={this.props.email} placeholder="your@email.com" />
							<button onClick={(event)=>this.props.uploadUserGenerator(event)}>Submit</button>
						</div>
					</form>
					<button className="skip" onClick={()=>this.props.goToInnerChapterByNumber(1)}>Skip the submission</button>
				</div>
			</div>);
	}
}

export default ArtworkSubmit;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/artwork-submit.js